import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  IP_ADDRESS,
  COUNTRY,
} from 'app/constants';
import { isEmpty } from 'ramda';

/**
 * [setLocalStorage description]
 */
const setLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * [getLocalStorage description]
 */
const getLocalStorage = (key: string) => {
  const rawData = localStorage.getItem(key);

  // Handle null or undefined values
  if (rawData === null || rawData === 'undefined' || rawData === undefined) {
    // Return appropriate fallback values for critical keys
    if (key === IP_ADDRESS) return 'unknown';
    if (key === COUNTRY) return 'unknown';
    return {};
  }

  try {
    const data = JSON.parse(rawData);

    // Additional validation for IP_ADDRESS and COUNTRY to ensure they're strings
    if (key === IP_ADDRESS) {
      return typeof data === 'string' && data.trim() !== '' ? data : 'unknown';
    }
    if (key === COUNTRY) {
      return typeof data === 'string' && data.trim() !== '' ? data : 'unknown';
    }

    return data;
  } catch (error) {
    // If JSON parsing fails, return appropriate fallbacks
    if (key === IP_ADDRESS) return 'unknown';
    if (key === COUNTRY) return 'unknown';
    return {};
  }
};

/**
 * [removeLocalStorage description]
 */
const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

/**
 * [getJwtLocalStorage description]
 */
const getJwtLocalStorage = () => {
  const accessToken = getLocalStorage(ACCESS_TOKEN);
  return !isEmpty(accessToken) ? accessToken : null;
};

const getRefreshTokenLocalStorage = () => {
  const refreshToken = getLocalStorage(REFRESH_TOKEN);
  return !isEmpty(refreshToken) ? refreshToken : null;
};

/**
 * Safely get IP address from localStorage, always returns a string
 */
const getIpAddressFromStorage = (): string => {
  const ipAddress = getLocalStorage(IP_ADDRESS);
  return typeof ipAddress === 'string' && ipAddress.trim() !== ''
    ? ipAddress
    : 'unknown';
};

/**
 * Safely get country from localStorage, always returns a string
 */
const getCountryFromStorage = (): string => {
  const country = getLocalStorage(COUNTRY);
  return typeof country === 'string' && country.trim() !== ''
    ? country
    : 'unknown';
};

export {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  getJwtLocalStorage,
  getRefreshTokenLocalStorage,
  getIpAddressFromStorage,
  getCountryFromStorage,
};
